import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { FaRegStar, FaStar } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const OrgDetailsDashboard = ({ agentDetails, closePanel, starred, toggleStar }) => {

  const data = [
    { name: "Accepted", value: agentDetails.Accepted, color: "#FF0080" },
    { name: "Rejected", value: agentDetails.Rejected, color: "#1E3A8A" },
    { name: "Pending", value: agentDetails.Pending, color: "#FFA500" },
  ];

  const handleEmailClick = () => {
    const userConfirmed = window.confirm("Do you want to open the email compose page?");
    if (userConfirmed) {
      window.open("https://mail.google.com/mail/?view=cm&fs=1", "_blank");
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2 style={styles.companyName}>{agentDetails.agentName}</h2>
        <div style={styles.iconContainer}>
        {starred ? (
  <FaStar style={{ ...styles.icon, color: "#FF0080" }} onClick={toggleStar} />
) : (
  <FaRegStar style={styles.icon} onClick={toggleStar} />
)}

          <MdEmail style={styles.icon} onClick={handleEmailClick} />
        </div>
      </div>

      <PieChart width={250} height={200}>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={50}
          outerRadius={100}
          dataKey="value"
          labelLine={false}
          label={({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
            const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
            const x = cx + radius * Math.cos(-midAngle * (Math.PI / 180));
            const y = cy + radius * Math.sin(-midAngle * (Math.PI / 180));
            return (
              <text
                x={x}
                y={y}
                fill="white"
                fontWeight="bold"
                textAnchor="middle"
                dominantBaseline="central"
              >
                {`${(percent * 100).toFixed(0)}%`}
              </text>
            );
          }}
        >
          {data.map((entry, index) => <Cell key={index} fill={entry.color} />)}
        </Pie>
        <Tooltip />
      </PieChart>

      <div style={styles.legend}>
        {data.map((entry, index) => (
          <div key={index} style={styles.legendItem}>
            <span style={{ ...styles.legendDot, backgroundColor: entry.color }}></span>
            {entry.name} <span style={styles.legendValue}>{entry.value}</span>
          </div>
        ))}
      </div>

      <button style={styles.closeButton} onClick={closePanel}>Close</button>
    </div>
  );
};





const styles = {
  container: {
    width: "350px",
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
  },
  companyName: {
    fontSize: "16px",
    fontWeight: "normal",
  },
  iconContainer: {
    display: "flex",
    gap: "10px",
  },
  icon: {
    fontSize: "16px",
    cursor: "pointer",
    color: "#FF0080",
  },
  summaryBox: {
    background: "#F4F4F5",
    padding: "10px",
    borderRadius: "6px",
    marginBottom: "15px",
    textAlign: "left",
  },
  summaryNumber: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#000",
  },
  summaryText: {
    fontSize: "12px",
    color: "#666",
    marginLeft: "5px",
  },
  legend: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    margin: "15px 0",
  },
  legendItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    fontSize: "12px",
    margin: "5px 0",
  },
  legendDot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    display: "inline-block",
    marginRight: "8px",
  },
  legendValue: {
    marginLeft: "auto",
  },
  tags: {
    display: "flex",
    gap: "5px",
    marginBottom: "15px",
  },
  tag: {
    padding: "5px 10px",
    borderRadius: "10px",
    fontSize: "10px",
    border: "1px solid #E0E0E0",
  },
  closeButton: {
    background: "#FF0080",
    color: "#fff",
    border: "none",
    padding: "8px 15px",
    borderRadius: "5px",
    fontSize: "12px",
    cursor: "pointer",
  },
};

export default OrgDetailsDashboard;
